import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-418f978c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "fullscreen_image__text",
  ref: "textlines"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_section = _resolveComponent("page-section")!
  const _directive_sanitize = _resolveDirective("sanitize")!

  return (_openBlock(), _createBlock(_component_page_section, {
    class: _normalizeClass(["fullscreen_image", `fullscreen_image--text-${_ctx.textPosition}`]),
    style: _normalizeStyle(`background-image:url(${_ctx.image.src})`),
    "data-reveal-on-scroll": "true"
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
        [_directive_sanitize, _ctx.text]
      ])
    ]),
    _: 1
  }, 8, ["class", "style"]))
}